var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoriesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "card",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H23.408",
    transform: "translate(2.296 9.922)",
    fill: "none",
    stroke: "#1c1842",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H2.3",
    transform: "translate(7.01 19.256)",
    fill: "none",
    stroke: "#1c1842",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H4.592",
    transform: "translate(12.289 19.256)",
    fill: "none",
    stroke: "#1c1842",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.2,0h13c4.167,0,5.208,1.033,5.208,5.155V14.8c0,4.122-1.042,5.155-5.2,5.155H5.2C1.042,19.964,0,18.93,0,14.808V5.155C0,1.033,1.042,0,5.2,0Z",
    transform: "translate(2.296 4.024)",
    fill: "none",
    stroke: "#1c1842",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesBlack);
export default __webpack_public_path__ + "static/media/categoriesBlack.ab14739842d70bb6b11143bc3d344fcd.svg";
export { ForwardRef as ReactComponent };